'use es6';

import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React from 'react';
import NotificationList from 'ReduxMessenger/components/NotificationList';
import UIApplication from 'UIComponents/app/UIApplication';
var AppContainer = createReactClass({
  displayName: "AppContainer",
  propTypes: {
    children: PropTypes.element.isRequired
  },
  render: function render() {
    return React.createElement(UIApplication, {
      className: "app-container",
      name: "MarketplaceUI"
    }, React.createElement(NotificationList, null), this.props.children);
  }
});
export default AppContainer;